import React from "react";
import FooterArabic from "./PrintArabic/Footer";
import BodyArabic from "./PrintArabic/body";

const PrintArabicSingle = () => {
    return (
        <div>
            <BodyArabic />
            <br />
            <br />
            <FooterArabic />
        </div>
    );
};

export default PrintArabicSingle;
